import { render, staticRenderFns } from "./caiGouOrderList.vue?vue&type=template&id=575c0876&"
import script from "./caiGouOrderList.vue?vue&type=script&lang=js&"
export * from "./caiGouOrderList.vue?vue&type=script&lang=js&"
import style0 from "./caiGouOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports